import { render } from "./MasterDataEmployeeDetail.vue?vue&type=template&id=0b676f50"
import script from "./MasterDataEmployeeDetail.vue?vue&type=script&lang=js"
export * from "./MasterDataEmployeeDetail.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__